import { Box, IconButton, Menu, MenuItem, Stack } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import { ThemeModeToggle } from "../theme-mode-toggle";
import SettingsIcon from "@mui/icons-material/Settings";
import MenuIcon from "@mui/icons-material/Menu";
import SecurityIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import { SidebarMenu } from "../sidebar-layout/sidebar-menu";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useUserContext } from "../../hooks/use-auth-context";
import { useCapabilities } from "../../hooks/use-capabilities";
import { Views } from "../../utils/types";
import { colors, whiteTint } from "../../utils/colors";

export const SettingsMenu = () => {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const { logout } = useUserContext();
  const { can } = useCapabilities();
  const navigate = useNavigate();

  const close = () => setAnchor(null);

  return (
    <div className="settings-menu">
      <IconButton
        sx={{
          color: colors.surface,
          transition: "background-color .2s ease",
          "&:hover": { bgcolor: whiteTint(0.08) },
        }}
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        <SettingsIcon
          className="settings-icon"
          sx={{
            display: { xs: "none", md: "block" },
          }}
        />
        <MenuIcon
          className="menu-icon"
          sx={{ display: { xs: "block", md: "none" } }}
        />
      </IconButton>

      <Menu
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          "& .MuiPaper-root": {
            background: colors.navy,
            border: `1px solid ${whiteTint(0.08)}`,
            mt: 0.5,
          },
          "& .MuiList-root": { p: 1 },
        }}
        open={!!anchor}
        anchorEl={anchor}
        onClose={close}
      >
        <Box
          className="mobile-sidebar-menu"
          sx={{
            display: { xs: "block", md: "none" },
          }}
        >
          <SidebarMenu onClose={close} />
        </Box>

        {can("manage_capabilities") && (
          <MenuItem
            onClick={() => { navigate(Views.CAPABILITIES); close(); }}
            sx={{ mb: 0.5, color: colors.surface, borderRadius: 1.5 }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <SecurityIcon fontSize="small" />
              <span>Capabilities</span>
            </Stack>
          </MenuItem>
        )}

        <MenuItem
          onClick={logout}
          sx={{ mb: 0.5, color: colors.surface, borderRadius: 1.5 }}
        >
          <Stack
            direction="row"
            alignItems="center"
            alignContent="flex-start"
            spacing={1}
          >
            <ExitToAppIcon fontSize="small" />
            <span>Logout</span>
          </Stack>
        </MenuItem>

        <ThemeModeToggle onClose={close} />
      </Menu>
    </div>
  );
};
